// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__XBdK2","header":"ReportDetails_header__mPXww","title":"ReportDetails_title__2-H9C","left":"ReportDetails_left__dF1DZ"};